import { ViewFactory } from 'wdc-cube-react'
import SerproScope, { HeaderScope } from '../serpro.scopes'
import SerproView from './serpro.view'
import HeaderView from './serpro.header'

export function registerViews(rv = ViewFactory.register) {
    rv(SerproScope, SerproView)
    rv(HeaderScope, HeaderView)
}
